import { render, staticRenderFns } from "./InvoiceStatusSnipet.vue?vue&type=template&id=64e71bbc"
import script from "./InvoiceStatusSnipet.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusSnipet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports